import { render, staticRenderFns } from "./ProductVariantSelect.vue?vue&type=template&id=b9a18458&"
import script from "./ProductVariantSelect.vue?vue&type=script&lang=ts&"
export * from "./ProductVariantSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports